export default {
    schema: Object
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoGanttDependencyDataSource/GanttDependencyDataSourceProps.js